import React from 'react';
import PropTypes from 'prop-types';
import { useBrowserHistory } from '@Utilities/services/hooks/useBrowserHistory';
import { IconButton as MUIIconButton } from '@mui/material';
import './styles/iconButton.scss';
import './styles/iconButtonV2.scss';

export const variantPropMap = {
  avatar: {
    variant: 'avatar',
    className: 'iconButton--avatar'
  },
  standardV2: {
    variant: '',
    className: 'iconButton--standard-v2'
  },
  filled: {
    variant: 'contained',
    className: 'iconButton--filled'
  },
  filledV2: {
    variant: 'contained',
    className: 'iconButton--filled-v2'
  },
  outlined: {
    variant: 'outlined',
    className: 'iconButton--outlined'
  },
  outlinedV2: {
    variant: 'outlined',
    className: 'iconButton--outlined-v2'
  },
  tonalV2: {
    variant: 'contained',
    className: 'iconButton--tonal-v2'
  },
  component: {
    variant: 'outlined',
    className: 'iconButton--component'
  },
  solid: {
    variant: 'solid',
    className: 'iconButton--solid'
  }
};

export default function IconButton({
  className: propClassName,
  variant,
  children,
  href,
  isExternalLink = false,
  onClick,
  ...buttonProps
}) {
  const browserHistory = useBrowserHistory();
  const MUIIconButtonProps = variant && variantPropMap[variant];
  const { className: variantClassName } = MUIIconButtonProps || {};
  function handleButtonClick(e) {
    if (!isExternalLink) {
      if (href) {
        e.preventDefault && e.preventDefault();
        browserHistory.push(href);
      }
      onClick && onClick(e);
    }
  }

  return (
    <MUIIconButton
      className={`${variantClassName ?? ''} ${propClassName ?? ''}`}
      onClick={handleButtonClick}
      href={href}
      disableRipple={variant === 'component'}
      disableFocusRipple
      {...buttonProps}
    >
      {children}
    </MUIIconButton>
  );
}

IconButton.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string,
  isExternalLink: PropTypes.bool,
  onClick: PropTypes.func
};
